import { EntityWithId } from 'src/types'

export const UnidadNegocioViewDTOFields = {
    Nombre: 'nombreUnidadNegocio',
    CodPais: 'codPais',
    NombrePais: 'nombrePais',
    Activo: 'activo'
} as const

export type UnidadNegocioViewDTO = EntityWithId & {
    [UnidadNegocioViewDTOFields.Nombre]: string
    [UnidadNegocioViewDTOFields.CodPais]: number | null
    [UnidadNegocioViewDTOFields.NombrePais]: string | null
    [UnidadNegocioViewDTOFields.Activo]: boolean
}

export type UnidadNegocioInsertDTO = {
    [UnidadNegocioViewDTOFields.Nombre]: string
    [UnidadNegocioViewDTOFields.CodPais]: number | null
}
